export default __webpack_public_path__ + "static/media/templates.998c2cca.svg";